import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ActivateIcon, DeactivateIcon } from 'assets/materialIcons/materialIcons';
import { closeModal, openConfirmModal, modalStartLoading } from 'store/actions/modalActions';
import { connect } from 'react-redux';

class ActiveStateButton extends React.Component {
    constructor(props) {
        super(props);

        this.sendRequest = this.sendRequest.bind(this);

        this.activate = 'activate';
        this.deactivate = 'deactivate';
    }

    setEvents = () => {
        const {
            openModal,
            resource,
            showLoader,
            translate,
        } = this.props;

        const activity = this.activity();

        openModal({
            actions: {
                submit: () => {
                    showLoader();

                    this.sendRequest();
                },
            },
            content: {
                description: translate(`resources.${ resource }.activity.${ activity }.description`),
            },
            title: translate(`resources.${ resource }.activity.${ activity }.title`),
        });
    }

    sendRequest = () => {
        const {
            active,
            closeModal,
            id,
            parameter,
            resource,
            sendFailure,
            sendSuccess,
        } = this.props;

        const url = `${ config.getApiBaseUrl() }/${ resource }/${ id }`;

        const values = {
            [parameter]: !active,
        };

        return apiClient.patch(url, values).then((response) => {
            sendSuccess(response);
        }, (error) => {
            sendFailure(error);
        }).then(() => {
            closeModal();
        });
    }

    activity = () => {
        return this.props.active ? this.deactivate : this.activate;
    }

    render() {
        const {
            active,
            resource,
            translate,
        } = this.props;

        const activity = this.activity();

        return (
            <Button
                icon={ active ? <DeactivateIcon color={ theme.palette.redOrange } style={ { transform: 'rotate(45deg)' } } /> : <ActivateIcon color={ theme.palette.doveGray } /> }
                onClick={ this.setEvents }
                title={ translate(`resources.${ resource }.actions.${ activity }`) }
            />
        );
    }
}

ActiveStateButton.defaultProps = {
    parameter: 'is_enabled',
};

ActiveStateButton.propTypes = {
    active: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    openModal: PropTypes.func.isRequired,
    parameter: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
    sendFailure: PropTypes.func.isRequired,
    sendSuccess: PropTypes.func.isRequired,
    showLoader: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, props) => {
    const { failureAction, successAction } = props;

    return {
        openModal: (payload) => {
            dispatch(openConfirmModal(payload));
        },
        closeModal: () => {
            dispatch(closeModal());
        },
        showLoader: () => {
            dispatch(modalStartLoading());
        },
        sendFailure: (error) => {
            dispatch(failureAction(error));
        },
        sendSuccess: (response) => {
            dispatch(successAction(response));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ActiveStateButton);



// WEBPACK FOOTER //
// ./src/components/button/ActiveStateButton.js